import { Typography } from "@mui/material";

function Title({ children, sx }) {
  return (
    <Typography
      component={"h2"}
      sx={{
        fontSize: "20px",
        // fontWeight: 500,
        fontWeight: "bold",
        color: "#000000DE",
        mb: "12px",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default Title;
